<template>
  <div>
    <div v-if="appointedcarrierdata.AppointedCarriers && appointedcarrierdata.AppointedCarriers.length === 0">No Carrier Appointed to this Agency</div>
    <b-row v-for="(subItem, subKey) in appointedcarrierdata.AppointedCarriers" :key="subKey" class="mx-3 py-4 border-bottom ac-carrier-container">
      <b-col sm="12" lg="3" xl="2" class="pl-0">
          <b-img :src="subItem.CarrierSvgLogoUrl" fluid-grow :alt="subItem.CarrierName"></b-img>
          <div class="m-2 smaller-font-content">{{ subItem.CarrierName }}</div>
        </b-col>
      <b-col sm="12" lg="9" xl="10" class="px-sm-0 pl-lg-3 pr-lg-0">
        <fieldset class="border border-primary p-2 rounded">
          <legend  class="w-auto px-2 font-weight-bold smaller-font-content text-primary">CARRIER APPOINTED STATES</legend>
            <div class="pb-2 smaller-font-content" v-if="checkPermission('UpdateUserAppointedCarriers')">
              <b-link @click="toggleAll(subItem.States,subKey,'selectall')">Select All</b-link> | <b-link @click="toggleAll(subItem.States,subKey,'clearall')">Clear Selected</b-link>
          </div>
          <b-form-group label="" class="w-full">
            <b-form-checkbox
              :disabled="isDisabled(option.IsEnabled, checkPermission('UpdateUserAppointedCarriers'))"
              v-for="(option, key) in subItem.States" :key="key"
              :name="'state_'+subItem.CarrierCode"
              v-model="option.IsActive"
              :id="'state_'+subItem.CarrierCode+'_'+option.StateCode"
              inline
              :class="stateCheckboxStyle(option.IsEnabled, checkPermission('UpdateUserAppointedCarriers'))">
              {{ option.StateName }} ({{ option.StateCode }})
            </b-form-checkbox>
          </b-form-group>
        </fieldset>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import common from '../../../services/common';

export default {
  props: ['appointedcarrierdata'],
  data() {
    return {
      name: '',
      id: '',
      classStyle: '',
      selected: [], // Must be an array reference!
    };
  },
  methods: {
    /**
     * check permission based on role
     */
    checkPermission(role) {
      return common.checkPermission(role);
    },
    toggleAll(states, subKey, toggleType) {
      if (toggleType === 'selectall') {
        Object.values(states).forEach((key) => {
          const stateKey = key;
          if (stateKey.IsEnabled === true) {
            stateKey.IsActive = true;
          }
        });
      }
      if (toggleType === 'clearall') {
        Object.values(states).forEach((key) => {
          const stateKey = key;
          if (stateKey.IsEnabled === true) {
            stateKey.IsActive = false;
          }
        });
      }
    },
    // eslint-disable-next-line no-unused-vars
    isDisabled(isEnabled, permission) {
      // eslint-disable-next-line no-unused-vars
      let isDisabled;
      if (isEnabled) {
        if (permission) {
          isDisabled = false;
        } else {
          isDisabled = true;
        }
      } else {
        isDisabled = true;
      }
      return isDisabled;
    },
    // eslint-disable-next-line no-unused-vars
    stateCheckboxStyle(isEnabled, permission) {
      if (isEnabled) {
        if (permission) {
          return 'fieldset-width smaller-font-content';
        }
        return 'fieldset-width smaller-font-content read-only-states';
      }
      return 'fieldset-width smaller-font-content';
    },
  },
};
</script>

<style scoped>
.ac-carrier-container {
  display:flex;
  align-items:center;
}
img.img-fluid{
  max-width: 180px;
  height: inherit !important;
}

@media (min-width: 1200px) {
  .fieldset-width {
    width: 18%;
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  .fieldset-width {
    width: 30%;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .fieldset-width {
    width: 29.5%;
  }
}

@media (min-width: 576px) and (max-width: 767px) {
  .fieldset-width {
    width: 44%;
  }
}

@media (max-width: 575px) {
  .fieldset-width {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/user/AppointedCarrier.vue?e7b7912a